const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Overview Assessments Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('managerGrader', ['Application', 'Authorization', 'Assessments', function (Application, Authorization, Assessments) {
  var self = this;
  self.user = Authorization.getAuthToken().user;
  self.isManager = self.user && self.user.is_manager;
  self.isGrader = false;
  self.activeTab = 'manager';

  Assessments.checkIfGrader().$promise
  .then(function(results) {
    self.isGrader = results && results.grader ? true : false;

    if (self.isManager) {
      self.isGrader = true;
    }

    if (!self.isGrader) {
      Application.navigation.goTo('/');
    }

    if (self.isGrader && !self.isManager) {
      self.activeTab = 'grader';
    }
  }).catch(function(error) {
    console.log('error in manager grader: ', error)
  });

}]);